<div class="flexable flex gap-2 p-2 rounded-xl">
  <div class="flex gap-1 items-center rounded-tab w-fit p-2">
    <span class="text-black">Warehouse: </span>
    <div>
      <!-- <mat-form-field appearance="outline">
        <mat-label>Select Warehouse</mat-label>
        <mat-select
          [(ngModel)]="filtering.warehouse"
          (selectionChange)="onFilterChange($event?.value, 'warehouse')"
        >
          @for (warehouse of warehouses$ | async; track warehouse) {
          <mat-option value="{{ warehouse?.uniqueId }}">{{
            warehouse?.name
          }}</mat-option>
          }
        </mat-select>
      </mat-form-field> -->
    <select
    [(ngModel)]="filtering.warehouse"
    (ngModelChange)="onFilterChange($event, 'warehouse')"
>
    <option [ngValue]="null">Choose Warehouse</option>
    <option *ngFor="let warehouse of warehouses$ | async" [ngValue]="warehouse?.uniqueId">
        {{ warehouse?.name }}
    </option>
</select>

    </div>
  </div>

  @if (filtering.warehouse && (warehouseSensors$ | async)?.length) {
  <div class="flex gap-4 items-center">
    <span class="font-bold">Sensor: </span>
    <div class="flex gap-2 items-center">
      <mat-form-field appearance="outline">
        <mat-label>Select Sensor</mat-label>
        <mat-select [(ngModel)]="filtering.sensor">
          @for (sensor of warehouseSensors$ | async; track sensor) {
          <mat-option value="{{ sensor?.uniqueId }}">{{
            sensor?.sensorName
          }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div *ngIf="filtering.sensor">
        <span
          (click)="filtering.sensor = null"
          class="pr-2.5 hover:bg-gray-300 cursor-pointer flex items-center rounded-full bg-gray-200 text-xs"
        >
          <mat-icon class="scale-50">clear</mat-icon> Clear
        </span>
      </div>
    </div>
  </div>
  }

  <div class="flex gap-4 items-center rounded-tab w-fit p-2">
    <span class="text-black">Timeframe: </span>
    <div class="flex items-center gap-1">
      @for (tab of timeframeTabs; track tab) { @if (tab?.name ===
      activeTimeframeTab) {
      <!-- <mat-chip class="!bg-primary-600 !text-white">
        <span class="text-white">{{ tab?.name }}</span>
      </mat-chip> -->
      <span
          class="!bg-[#3A7AA8] !text-white !px-[12px] rounded-full !py-[8px]"
        >
          <span class="text-white text-[13px] relative">{{ tab?.name }}</span>
        </span>
      } @else {
      <!-- <mat-chip
        (click)="
          activeTimeframeTab = tab?.name; onFilterChange(tab?.name, 'timeframe')
        "
        class="!cursor-pointer"
        >{{ tab?.name }}
      </mat-chip> -->
      <span
          (click)="
            activeTimeframeTab = tab?.name;
            onFilterChange(tab?.name, 'timeframe')
          "
          class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8]"
          >{{ tab?.name }}</span>
      } } @if (activeTimeframeTab) {
      <!-- <mat-chip
        (click)="
          activeTimeframeTab = null;
          filtering.dateTo = null;
          filtering.dateFrom = null
        "
        class="cursor-pointer"
      >
        <fa-icon [icon]="faCalendar"></fa-icon>
        Custom Date
      </mat-chip> -->
      <div
          (click)="
            activeTimeframeTab = null;
            filtering.dateTo = null;
            filtering.dateFrom = null
          "
          class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8] !w-fit flex !min-w-[132px] gap-1"
        >
          <fa-icon [icon]="faCalendar"></fa-icon>
          <span>Custom Date</span>
        </div>
      } @else {
      <!-- <mat-chip class="cursor-pointer !bg-primary-600">
        <span class="text-white">
          <fa-icon [icon]="faCalendar"></fa-icon>
          Custom Date
        </span>
      </mat-chip> -->
      <span
          class="!cursor-pointer !bg-[#3A7AA8] !px-[12px] rounded-full !py-[8px] !min-w-[132px] gap-1"
        >
          <span class="text-white !text-[13px]">
            <fa-icon [icon]="faCalendar"></fa-icon>
            Custom Date
          </span>
        </span>
      }

      <div
          class="flex gap-1"
          [ngStyle]="{ display: activeTimeframeTab ? 'none' : '' }">
        <!-- <mat-form-field appearance="outline">
          <mat-label>Start Date</mat-label>
          <input
            matInput
            [(ngModel)]="startDate"
            (dateChange)="onFilterChange(null, 'dateFrom')"
            [disabled]="activeTimeframeTab"
            [matDatepicker]="startDatePicker"
            placeholder="Select Start Date"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>End Date</mat-label>
          <input
            matInput
            [(ngModel)]="endDate"
            (dateChange)="onFilterChange(null, 'dateTo')"
            [disabled]="activeTimeframeTab"
            [matDatepicker]="endDatePicker"
            placeholder="Select End Date"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="endDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field> -->

          <div class="custom-date-input-container">
            <input
              type="text"
              class="custom-date-input"
              [max]="endDate"
              [(ngModel)]="startDate"
              (dateChange)="onFilterChange(null, 'dateFrom')"
              [disabled]="activeTimeframeTab"
              [matDatepicker]="startDatePicker"
              placeholder="Select Start Date"
              readonly
              (click)="startDatePicker.open()"
            />
            <button
              class="calendar-button"
              mat-icon-button
              [disabled]="activeTimeframeTab"
              (click)="startDatePicker.open()"
            >
              <img src="assets/icons/calendar-02.png" alt="" srcset="" />
            </button>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </div>
          <div class="custom-date-input-container">
            <input
              type="text"
              class="custom-date-input"
              [(ngModel)]="endDate"
              [min]="startDate"
              (dateChange)="onFilterChange(null, 'dateTo')"
              [disabled]="activeTimeframeTab"
              [matDatepicker]="endDatePicker"
              placeholder="Select End Date"
              readonly
              (click)="endDatePicker.open()"
            />
            <button
              class="calendar-button"
              mat-icon-button
              [disabled]="activeTimeframeTab"
              (click)="endDatePicker.open()"
            >
              <img src="assets/icons/calendar-02.png" alt="" srcset="" />
            </button>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </div>
      </div>
    </div>
  </div>

  <div class="flex justify-end">
    <button
      (click)="generateReport()"
      class="rounded-full py-[8px] px-[12px] flex gap-2 text-[13px] font-normal bg-[#dbdbdb] text-[#9b9b9b]"
      [ngClass]="{
        '!bg-[#025590] !text-white': filtering.warehouse && filtering.warehouse !== 'null',
        ' cursor-not-allowed': !filtering.warehouse && filtering.warehouse === 'null'
      }" [disabled]="!filtering.warehouse || filtering.warehouse === 'null'"
    >
      <!-- <mat-icon>summarize</mat-icon> -->
      Generate
    </button>
  </div>
</div>

<div class="mt-8">
  <app-pdf-viewer
    *ngIf="reportData"
    class="w-full"
    [base64Src]="reportData"
    [filenameForDownload]="'title'"
  ></app-pdf-viewer>
</div>
